import React from "react";
import { BarChart3, Users, CreditCard, IndianRupee, Calendar, UserCheck, UserMinus, TrendingUp, FileText, BarChart2, Globe, Settings, Database, TestTube, UserCog, Mail, Building2, Wrench, Activity, Target, Bell, FileCode, List, Send } from "lucide-react";
import userStore from "../utils/UserStore";

const SidePanel = ({ navigateTo, activePage, isOpen }) => {
    // Main navigation items (always visible)
    const mainMenuItems = [
        {
            id: "analytics",
            label: "Growth",
            icon: BarChart3,
        },
        // {
        //     id: "event-track",
        //     label: "Event Track",
        //     icon: Activity,
        // },
        // {
        //     id: "upgrade-nudge-event-track",
        //     label: "Upgrade Nudge Event Track",
        //     icon: Bell,
        // },
        {
            id: "payment-events",
            label: "Payment Events",
            icon: CreditCard,
        },
        {
            id: "stripe",
            label: "Stripe",
            icon: CreditCard,
        },
        {
            id: "razorpay",
            label: "Razorpay",
            icon: IndianRupee,
        },
        {
            id: "upcoming-renewals",
            label: "Renewals",
            icon: Calendar,
        },
        {
            id: "renewal-cancellation",
            label: "Renewal Actions",
            icon: TrendingUp,
        },
        {
            id: "paid-users",
            label: "Paid Users",
            icon: UserCheck,
        },
        {
            id: "signup-to-payment",
            label: "Signup to Payment",
            icon: TrendingUp,
        },
        {
            id: "score-boot-analytics",
            label: "Presentation Score",
            icon: Target,
        },
        {
            id: "doc-created-before-subscription",
            label: "Doc created before subscription",
            icon: FileText,
        },
        {
            id: "free-users",
            label: "Free Users",
            icon: UserMinus,
        },
        {
            id: "cohort-analysis",
            label: "Cohort Analysis",
            icon: BarChart2,
        },
        {
            id: "user-doc-analysis",
            label: "Doc Analysis",
            icon: FileText,
        },
        {
            id: "daily-report",
            label: "Daily Report",
            icon: Globe,
        },
        {
            id: "google-ads-report",
            label: "Google Ads",
            icon: Building2,
        },
        {
            id: "user-grouping",
            label: "User Grouping",
            icon: Users,
        },
        {
            id: "campaign-list",
            label: "Campaign List",
            icon: List,
        },
        {
            id: "score-sheet-campaigns",
            label: "Score Sheet Campaigns",
            icon: FileText,
        },
    ];

    // Admin-only items (Tools section)
    const adminMenuItems = [
        {
            id: "users",
            label: "Users",
            icon: Users,
        },
        {
            id: "api-test",
            label: "API Test",
            icon: TestTube,
        },
        {
            id: "cronJob",
            label: "Cron Job",
            icon: Settings,
        },
        {
            id: "querybuilder",
            label: "Query Builder",
            icon: Database,
        },
        {
            id: "user-management",
            label: "User Management",
            icon: UserCog,
        },
        {
            id: "unsubscriber",
            label: "Unsubscriber",
            icon: Mail,
        },
        {
            id: "cron-email-template",
            label: "Cron Email Template",
            icon: FileCode,
        },
        {
            id: "bulk-mail-campaign",
            label: "Bulk Mail Campaign",
            icon: Send,
        },
        // {
        //     id: "stage-template",
        //     label: "Stage Template",
        //     icon: FileCode,
        // },
    ];

    const MenuItem = ({ item, isActive }) => {
        const Icon = item.icon;

        return (
            <button onClick={() => navigateTo && navigateTo(item.id)} className={`w-full flex items-center px-4 py-3 text-left text-sm transition-colors ${isActive ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600" : "text-gray-700 hover:bg-gray-50"}`}>
                <Icon className={`w-5 h-5 mr-3 ${isActive ? "text-blue-600" : "text-gray-400"}`} />
                <span>{item.label}</span>
            </button>
        );
    };

    if (!isOpen) return null;

    return (
        <div className="fixed top-0 left-0 h-screen w-72 bg-white shadow-lg z-40 transform transition-transform duration-300 ease-in-out flex flex-col">
            {/* Custom Scrollbar Styles */}
            <style
                dangerouslySetInnerHTML={{
                    __html: `
                    .sidepanel-scroll::-webkit-scrollbar {
                        width: 6px;
                    }
                    .sidepanel-scroll::-webkit-scrollbar-track {
                        background: #F7FAFC;
                        border-radius: 3px;
                    }
                    .sidepanel-scroll::-webkit-scrollbar-thumb {
                        background: #CBD5E0;
                        border-radius: 3px;
                    }
                    .sidepanel-scroll::-webkit-scrollbar-thumb:hover {
                        background: #A0AEC0;
                    }
                `,
                }}
            />

            {/* Header */}
            <div className="p-2 pl-4 border-b border-gray-200 flex-shrink-0">
                <h2 className="text-base font-semibold text-gray-900">Analytics dashboard</h2>
                <p className="text-sm text-gray-500">Event tracking</p>
            </div>

            {/* Menu Items with Custom Scrollbar */}
            <div
                className="flex-1 overflow-y-auto sidepanel-scroll"
                style={{
                    scrollbarWidth: "thin",
                    scrollbarColor: "#CBD5E0 #F7FAFC",
                }}
            >
                <nav className="py-2">
                    {/* Main Menu Items */}
                    {mainMenuItems.map((item) => (
                        <MenuItem key={item.id} item={item} isActive={activePage === item.id} />
                    ))}

                    {/* Tools Section - Only for Admin Users */}
                    {userStore.isLoggedIn() && !userStore.isDemoUser() && (
                        <>
                            {/* Tools Heading */}
                            <div className="px-4 py-2 mt-4 mb-2">
                                <div className="flex items-center text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                    <Wrench className="w-4 h-4 mr-2" />
                                    <span>Tools</span>
                                </div>
                            </div>

                            {/* Admin Menu Items */}
                            {adminMenuItems.map((item) => (
                                <MenuItem key={item.id} item={item} isActive={activePage === item.id} />
                            ))}
                        </>
                    )}
                </nav>
            </div>

            {/* Live Status */}
            <div className="p-4 border-t border-gray-200 flex-shrink-0">
                <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                    <div className="flex items-center justify-center space-x-2">
                        <div className="relative">
                            <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                            <div className="absolute inset-0 w-3 h-3 bg-green-400 rounded-full animate-ping opacity-75"></div>
                        </div>
                        <span className="text-sm font-medium text-gray-700">Live</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SidePanel;
